export const FETCH_USER_PENDING = 'FETCH_USER_PENDING';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_LOGOUT_PENDING = 'SET_LOGOUT_PENDING';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';

export const FETCH_SSO_CREDS_PENDING = 'FETCH_SSO_CREDS_PENDING';
export const FETCH_SSO_CREDS_SUCCESS = 'FETCH_SSO_CREDS_SUCCESS';
export const FETCH_SSO_CREDS_FAILURE = 'FETCH_SSO_CREDS_FAILURE';

export const SIGNIN_PENDING = 'SIGNIN_PENDING';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE';
export const CLEAR_SIGNIN = 'CLEAR_SIGNIN';

export const FETCH_RESTAURANTS_PENDING = 'FETCH_RESTAURANTS_PENDING';
export const FETCH_RESTAURANTS_SUCCESS = 'FETCH_RESTAURANTS_SUCCESS';
export const FETCH_RESTAURANTS_FAILURE = 'FETCH_RESTAURANTS_FAILURE';
export const CLEAR_RESTAURANTS = 'CLEAR_RESTAURANTS';

export const SAVE_RESTAURANT_PENDING = 'SAVE_RESTAURANT_PENDING';
export const SAVE_RESTAURANT_SUCCESS = 'SAVE_RESTAURANT_SUCCESS';
export const SAVE_RESTAURANT_FAILURE = 'SAVE_RESTAURANT_FAILURE';

export const SET_SEARCH_DATES = 'SET_SEARCH_DATES';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_ID_APP_LOADING = 'SET_ID_APP_LOADING';
export const REMOVE_ID_APP_LOADING = 'REMOVE_ID_APP_LOADING';
export const CLEAR_APP_LOADING = 'CLEAR_APP_LOADING';

export const SET_APP_ERROR = 'SET_APP_ERROR';
export const REMOVE_APP_ERROR = 'REMOVE_APP_ERROR';
export const CLEAR_APP_ERROR = 'CLEAR_APP_ERROR';

export const FETCH_RESTAURANT_PENDING = 'FETCH_RESTAURANT_PENDING';
export const FETCH_RESTAURANT_SUCCESS = 'FETCH_RESTAURANT_SUCCESS';
export const FETCH_RESTAURANT_FAILURE = 'FETCH_RESTAURANT_FAILURE';

export const FETCH_LINKED_VENUES_PENDING = 'FETCH_LINKED_VENUES_PENDING';
export const FETCH_LINKED_VENUES_SUCCESS = 'FETCH_LINKED_VENUES_SUCCESS';
export const FETCH_LINKED_VENUES_FAILURE = 'FETCH_LINKED_VENUES_FAILURE';

export const SET_ACTIVE_RESTAURANT = 'SET_ACTIVE_RESTAURANT';
export const SET_ACTIVE_RESTAURANT_ID = 'SET_ACTIVE_RESTAURANT_ID';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

export const OBEE_ONBOARD_SUCCESS = 'OBEE_ONBOARD_SUCCESS';

// API requests
export const ADD_API_REQUEST = 'ADD_API_REQUEST';
export const REMOVE_API_REQUEST = 'REMOVE_API_REQUEST';
